module.exports = __webpack_public_path__ + "img/retirement_logo.cd25dfe0.webp";